import React from 'react'

export default function Terms() {

    return (
        <div className={` globalcenter pb-5`}>
            <h1 className='mb-5'>Term & Conditions</h1>
            <hr />
            <h4>Customer Care</h4>
            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Recusandae optio, rem excepturi debitis deserunt quaerat porro est laboriosam laudantium velit dignissimos ea repudiandae exercitationem neque. Excepturi incidunt vitae aliquid pariatur.</p>
            <h4>Privacy & Safety</h4>
            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Recusandae optio, rem excepturi debitis deserunt quaerat porro est laboriosam laudantium velit dignissimos ea repudiandae exercitationem neque. Excepturi incidunt vitae aliquid pariatur.</p>
            <h4>Wholesale Inquiries</h4>
            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Recusandae optio, rem excepturi debitis deserunt quaerat porro est laboriosam laudantium velit dignissimos ea repudiandae exercitationem neque. Excepturi incidunt vitae aliquid pariatur.</p>
        </div>
    )
}
